/**
 * @fileoverview 封装paris sdk
 * @author zhangzhuo10
 * @link {https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/joG4Bod-HW/c8ao3cJbZr/Dp3NNc5C9m1og0} 地图微详情打款活动接入风控一体化服务文档
 * @link {https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/joG4Bod-HW/cuv64FB8Ez/X1ARCvJPGedXeq} 百度安全风控JSSDK接入文档-V3
 *
 */
import ParisFactory from '@baidu/paris';

const sak = '46e7738a2f';
let parisInstance = null;

// 初始化sdk
export function initParisInstance() {
    return new Promise((resolve, reject) => {
        parisInstance = ParisFactory.create({
            sak: sak,
            bantiUrl: `https://banti-static.cdn.bcebos.com/o/static/banti_${sak}.js`,
            // bantiUrl: ' https://banti-static.bj.bcebos.com/o/static/banti_46e7738a2f.js',

            bantiOptions: {
                reportTimeout: 0, // 上报超时时间，核心js版本1.14.0.0后默认5000（ms）对性能要求较高的业务可以设置0（ms）
                subid: function () {
                    // 返回当前页面子渠道号
                    return '';
                }
            }
        });
        parisInstance.getBantiInitResponse((error, response) => {
            if (error) {
                // 处理异常
                reject(error);
                return;
            }
            resolve(response);
            // 处理response
        });
    });
}
// 获取jstoken
export function getJstoken(timer) {
    return new Promise((resolve, reject) => {
        if (!parisInstance) {
            resolve('');
            return;
        }
        const sendBant = new Promise((resolve, reject) => {
            parisInstance.sendBantiReport({
                subid: '' // 返回当前业务场景子渠道号
            }, (error, response) => {
                if (error) {
                    // 处理异常
                    resolve('');
                    return;
                }
                // 处理response
                resolve(response);
            });
        });
        Promise.race([sendBant, asyncTimer(timer)]).then(res => {
            resolve(res);
        });
    });
}
// 获取oncetoken
export function getOncetoken(time) {
    return new Promise((resolve, reject) => {
        if (!parisInstance) {
            resolve('');
            return;
        }
        const _getToken = new Promise((resolve, reject) => {
            parisInstance.getBantiInstance(err => {
                window.Banti.getInstanceBySak(sak).getot((ot, errMsg) => {
                    // ot 即是 oncetoken
                    resolve(ot);
                });
            });
        });
        Promise.race([_getToken, asyncTimer(time)]).then(res => {
            resolve(res);
        });
    });
}
// 获取ztoken
export function getZid(time) {
    return new Promise((resolve, reject) => {
        if (!parisInstance) {
            resolve('');
            return;
        }
        const _getToken = new Promise((resolve, reject) => {
            parisInstance.hgzAs((err, zid) => {
                if (err) {
                    resolve('');
                    return;
                }
                // handle zid
                resolve(zid);
            });
        });
        Promise.race([_getToken, asyncTimer(time)]).then(res => {
            resolve(res);
        });
    });
}

function asyncTimer(timer) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve('');
        }, timer);
    });
}

export function getJsOnceToken(timer = 200) {
    return new Promise((resolve, reject) => {
        Promise.allSettled([getOncetoken(timer), getJstoken(timer), getZid(timer)]).then(results => {
            const tokenObj = {
                oztoken: '',
                jstoken: '',
                ztoken: ''
            };
            tokenObj.oztoken = results[0].value || '';
            tokenObj.jstoken = results[1]?.value?.htj?.jt || '';
            tokenObj.ztoken = results[2].value || '';
            resolve(tokenObj);
        });
    });
}

